import { RouteRecordRaw } from 'vue-router'

const adminRouter: RouteRecordRaw = {
  path: '/admin',
  name: 'admin-layout',
  component: () => import('@/layout/admin-layout.vue'),
  children: [
    {
      path: '/admin/firm-lists',
      name: 'firm-lists',
      component: () => import('@/views/admin/firm-management/firm-lists.vue'),
      meta: { silder: '企业绑定管理', img: '1', auth: 'lqdwxx' }
    },
    {
      path: '/admin/account-lists',
      name: 'account-lists',
      component: () => import('@/views/admin/account-management/account-lists.vue'),
      meta: { silder: '账号管理', img: '2', auth: 'user' }
    },
    {
      path: '/admin/auth/:type',
      name: 'role-auth',
      component: () => import('@/views/admin/authority-management/role-permission.vue'),
      meta: { silder: '角色与权限管理', img: '3', auth: 'role' }
    },
    {
      path: '/admin/application',
      name: 'application-management',
      component: () => import('@/views/admin/application-management/application-lists.vue'),
      meta: { silder: '应用管理', img: '4', auth: 'yygl' }
    },
    {
      path: '/admin/parameter-configuration',
      name: 'parameter-configuration',
      meta: { silder: '参数配置', img: 'parameter', auth: 'cspz' },
      children: [
        {
          path: '/admin/parameter-configuration/mail-box',
          name: 'mail-box',
          component: () => import('@/views/admin/parameter-configuration/mail-box/mail-box.vue'),
          meta: { silder: '发件邮箱配置', auth: 'cspz.emaipz' }
        },
        {
          path: '/admin/parameter-configuration/credit-granting',
          name: 'credit-granting',
          component: () => import('@/views/admin/parameter-configuration/credit-granting/credit-granting.vue'),
          meta: { silder: '授信额度配置', auth: 'cspz.sxedpz' }
        },
        {
          path: '/admin/parameter-configuration/limit-warning',
          name: 'limit-warning',
          component: () => import('@/views/admin/parameter-configuration/limit-warning/limit-warning.vue'),
          meta: { silder: '限额预警配置', auth: 'cspz.xeyjpz' }
        },
        {
          path: '/admin/parameter-configuration/:w+',
          redirect: '/admin/parameter-configuration/mail-box',
          meta: { show: false }
        }
      ]
    },
    {
      path: '/admin/log',
      name: 'admin-log',
      // component: () => import('@/views/admin/log-management/transfer-log.vue'),
      meta: { silder: '日志管理', img: '6', auth: 'log' },
      children: [
        // {
        //   path: '/admin/log/transfer',
        //   name: 'transfer-log',
        //   component: () => import('@/views/admin/log-management/transfer-log.vue'),
        //   meta: { silder: '调用日志', auth: 'log.lqlog' }
        // },
        {
          path: '/admin/log/login',
          name: 'login-log',
          component: () => import('@/views/admin/log-management/login-log.vue'),
          meta: { silder: '登录日志', auth: 'log.actionRecord' }
        },
        {
          path: '/admin/log/system',
          name: 'system-log',
          component: () => import('@/views/admin/log-management/system-log.vue'),
          meta: { silder: '系统操作日志', auth: 'log.systemLog' }
        }
        // {
        //   path: '/adming/log/data',
        //   name: 'data-log',
        //   component: () => import('@/views/admin/log-management/data-log.vue'),
        //   meta: { silder: '数据操作日志', auth: 'log.loginLog' }
        // }
      ]
    },
    {
      path: '/admin',
      redirect: '/admin/firm-lists',
      meta: { show: false }
    },
    {
      path: '/admin/:w+',
      redirect: '/admin/firm-lists',
      meta: { show: false }
    }
  ]
}
export default adminRouter
